import React from 'react';

const Docs = ({ width = '12', height = '15', className, color, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      {...rest}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 15"
      role="img"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M0.625 12.2917V2.29167C0.625 1.84964 0.800595 1.42572 1.11316 1.11316C1.42572 0.800595 1.84964 0.625 2.29167 0.625H10.625C10.8018 0.625 10.9714 0.695238 11.0964 0.820262C11.2214 0.945286 11.2917 1.11486 11.2917 1.29167V13.2917C11.2917 13.4685 11.2214 13.638 11.0964 13.7631C10.9714 13.8881 10.8018 13.9583 10.625 13.9583H2.29167C1.84964 13.9583 1.42572 13.7827 1.11316 13.4702C0.800595 13.1576 0.625 12.7337 0.625 12.2917ZM0.625 12.2917C0.625 11.8496 0.800595 11.4257 1.11316 11.1132C1.42572 10.8006 1.84964 10.625 2.29167 10.625H11.2917M3.29167 6.625H8.625M3.29167 3.95833H7.29167"
        stroke="#6E7781"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export { Docs };
